import React from 'react';

import Seo from '@/components/Seo';
import Container from '@/components/Container';
import ContactForm from '@/components/ContactForm';
import Spacer from '@/components/Spacer';

export interface Props {}

const ContactPage: React.FC<Props> = () => (
  <React.Fragment>
    <Seo
      title="Contact me"
      description="Do you have a cool product idea in your mind and you are looking for someone to bring it to life? I’m here for you!"
    />

    <Container>
      <Spacer xs={8} />

      <ContactForm />

      <Spacer xs={8} sm={8} md={8} lg={12} />
    </Container>
  </React.Fragment>
);

export default ContactPage;
